<template>
  <div class="printCoupon">
    <template v-if="couponlist.length>0">
      <div
      class="list"
      :class="{bodcls_active:selCoupon.id===item.id}"
      v-for="item in couponlist"
      :key="item.id"
    >
      <div class="listt">
        <div
          class="money oneline"
          :class="{footgray:daojishi(item.end_time)===2||(use&&item.condition>use)}"
        >
          <span class="mf" v-if="item.methods">￥</span>
          {{ item.methods ? item.fee : zhekou(item.fee) }}
          <span class="mf" v-if="!item.methods">折</span>
        </div>
        <div class="info">
          <div class="name oneline">
            <div class="oneline">
              {{ item.name }}
            </div>
            <div class="guoqi" v-if="daojishi(item.end_time)===1">
              即将过期
            </div>
          </div>
          <div class="time oneline">有效期至：{{ item.end_time }}</div>
        </div>
        <div v-if="daojishi(item.end_time)!==2">
          <div
            v-if="!use||item.condition<=use"
            @click.stop="goUse(item)"
            class="btn"
          >
            去使用
          </div>
          <div v-else class="btn gray">不可用</div>
        </div>
        <div v-else class="btn gray">已过期</div>
      </div>
      <div class="listm">
        <div class="ball bl"></div>
        <div class="line"></div>
        <div class="ball br"></div>
      </div>
      <div class="listb">
        ·单笔订单满{{ item.condition }}元可用 ·{{item.coupon_category|couponTip}}
      </div>
    </div>
    <div class="cancelwrap" @click.stop="cancelsel" v-if="use">
      取消使用优惠券
    </div>
    </template>
    <div v-else class="nowrap">
      <img src="@/assets/nodata.png" class="noimg">
      <p class="notext">暂无优惠券</p>
    </div>
  </div>
</template>

<script>
import { mapState,mapMutations } from "vuex";
import {formatNumber} from '@/utils/utils'
export default {
  data(){
      return {
        use:null
      }
  },
  computed: {
    ...mapState(["couponlist","selCoupon"]),
  },
  filters:{
    couponTip(couponstate){
      let obj={
        'usual':'电子照冲印照通用',
        'ele':'仅限于电子证件照',
        'print':'仅限于冲印证件照'
      }
      return obj[couponstate] || obj.usual
    }
  },
  activated(){
    let {use} = this.$route.params
    this.use=use
  },
  methods:{
      ...mapMutations(['SELCOUPON']),
      goUse(obj){
            this.SELCOUPON(obj)
            this.$router.go(-1)
        },
        cancelsel(){
            this.SELCOUPON({})
            this.$router.go(-1)
        },
      daojishi(str){
        //0为正常1为还有3天2为过期
        var d = new Date()
        var dstr = d.getFullYear()+'-'+formatNumber(d.getMonth()+1)+'-'+formatNumber(d.getDate())
        var timeS = new Date(dstr).getTime()
        var time_0S = new Date(str).getTime()
        if(time_0S<timeS){
            //过期
            return 2
        }
        var time_3 = new Date(str)
        time_3.setDate(time_3.getDate()-3)
        var time_3S = time_3.getTime()
        if(time_3S>timeS){
            return 0
        }else{
            return 1
        }
    },
    zhekou(fee){
        return fee*10
    }
  }
};
</script>

<style scoped>
.oneline{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis
}
.printCoupon{
  background-color: #F5F7FA;
  box-sizing: border-box;
  padding: 20px 16px 77.5px;
  min-height:100vh;
  position: relative;
}
.nowrap{
  text-align: center;
  position: absolute;
  left:50%;
  top:50%;
  transform: translate(-50%,-60%);
}
.noimg{
  width:200px;
  height:200px;
  display: block;
  margin:0 auto;
}
.list{
  background-color: white;
  border-radius: 10px;
  margin-bottom: 8px;
}
.listt{
  display: flex;
  box-sizing: border-box;
  padding:15px 16px 12px;
  align-items: center;
}
.money{
  flex-shrink: 0;
  color:#FF6763;
  font-size: 25px;
  font-weight: bold;
  min-width:60px;
  margin-right: 2.5px;
}
.mf{
  font-size: 16px;
}
.info{
  flex-grow: 1;
  overflow:hidden;
}
.name{
  font-size: 14px;
  color:#303133;
  font-weight: bold;
  display: flex;
  align-items: center;
}
.guoqi{
  flex-shrink: 0;
  width:49px;
  height:16px;
  font-size: 10px;
  color:#FF5555;
  background-color: rgba(255, 85, 85, 0.1);
  text-align: center;
  line-height: 16px;
  border-radius: 2.5px;
  margin-left: 8px;
}
.time{
  font-size: 12px;
  color:rgba(48, 49, 51, 0.4);
  margin-top: 4px;
}
.btn{
  flex-shrink: 0;
  margin-left: 5px;
  width:64px;
  height:28px;
  border-radius: 14px;
  background-color: #FF5555;
  font-size: 13px;
  color:white;
  text-align: center;
  line-height: 28px;
}
.btncls{
  background-color: rgba(255, 85, 85, 0.7);
}
.listm{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ball{
  width:7px;
  height:14px;
  background-color: #F5F7FA;
  flex-shrink: 0;
}
.bl{
  border-top-right-radius: 7px;
  border-bottom-right-radius: 7px;
}
.br{
  border-top-left-radius: 7px;
  border-bottom-left-radius: 7px;
}
.line{
  border-top: 1px dashed #E5E5EA;
  flex-grow: 1;
  margin:0 9px;
}
.listb{
  box-sizing: border-box;
  padding:0 17px 15px;
  font-size:10px;
  color:rgba(48, 49, 51, 0.4);
}
.footgray{
  color:#E5E5EA;
}
.gray{
  background-color: #E5E5EA;
}
.bodcls_active{
  border:1px solid #FF5555;
}
.bodcls_active .bl{
  margin-left: -1px;
  border-right: 1px solid #FF5555;
}
.bodcls_active .br{
  margin-right: -1px;
  border-left: 1px solid #FF5555;
}
.bodcls_active .bl,.bodcls_active .br{
  border-top:1px solid #FF5555;
  border-bottom:1px solid #FF5555;
}
.cancelwrap{
  position: fixed;
  height:74px;
  background-color: #D8D8D8;
  width:100%;
  left:0;
  bottom:0;
  font-size: 14px;
  color:rgba(48, 49, 51, 0.6);
  text-align: center;
  box-sizing: border-box;
  padding-top:16px;
  font-weight: bold;
}
.cls{
  background-color: rgba(229, 229, 234, 1);
}
</style>